import { request } from '@/utils'

export default {

  // 获取教师列表
  async findTeachers(data) {
    return request({
      path: '/teacher',
      query: data,
    })
  },

  // 获取杰出人才列表
  async findTalentTeachers(data) {
    return request({
      path: '/teacher',
      query: data,
    })
  },

  // 获取博士后
  async findPostdoctoral(data) {
    return request({
      path: '/teacher',
      query: data,
    })
  },

  // 获取人才培养导师列表
  async findCultiveTeacher(data) {
    return request({
      path: '/teacher',
      query: data,
    })
  },

  // 获取教师研究方向
  async findResearch() {
    return request({
      path: '/teacherResearch'
    })
  },

  // 获取教师职称
  async findTitle() {
    return request({
      path: '/teacherTitle'
    })
  },

  // 获取教师类别
  async findTalent() {
    return request({
      path: '/teacherTalent'
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/teacher.js